import ModalView from '../../../js/components/ModalView';
import templateAdvancedSearch from '../templates/_AdvancedSearchFormOverlay.hbs';
import AdvancedSearchController from './AdvancedSearchController';
import config from '../../../js/config';
import Analytics from '../../Analytics/Analytics';
import $ from 'jquery';

let instance = null;

export default class AdvancedSearchModalView extends ModalView {

  initialize() {
    super.initialize({ template: templateAdvancedSearch, remodal: { closeOnOutsideClick: false } });
  }

  initializeElements() {
    this.$form = $(this.el).find('form');

    this.$searchTextBox = this.$form.find('#searchTerm');
    this.$submitButton = this.$form.find('#submit');
    this.$errorMessage = this.$form.find('#errorMessage');
    this.$searchInStockCheckbox = this.$form.find('#instock');
    this.$searchTopPurchasedCheckbox = this.$form.find('#topPurchased');
    this.$searchTopSearchedCheckbox = this.$form.find('#topSearched');
    this.$searchNewCheckbox = this.$form.find('#newProduct');
    this.$closeIcon = this.$form.find('.AdvancedSearchContent-close');
    this.$categoryList = this.$form.find('#AdvSearchCategoriesCategory');
    this.$manufacturerList = this.$form.find('#AdvSearchCategoriesManufacturer');
    this.$parametricList = this.$form.find('#AdvSearchParametric');
    this.$parametricListText = this.$form.find('#ParametricLabel');
    this.$parametricValueList = this.$form.find('#AdvSearchParametricValue');
    this.$parametricValueListText = this.$form.find('#ParametricValueLabel');
    this.$manufacturerLabel = this.$form.find('#ManufacturerLabel');
    this.$categoryLabel = this.$form.find('#CategoryLabel');
    this.$manufacturerForCategoryLabel = this.$form.find('#ManufacturerForCategoryLabel');
    this.$clearManufacturer = this.$form.find('#ClearManufacturer');
    this.$clearCategory = this.$form.find('#ClearCategory');
    this.$advMoreParametrics = this.$form.find('#AdvParametricMore');
    this.$parametricValues = this.$form.find('#parametricValues');
    this.$advancedSearchManufacturerContainer = this.$form.find('#AdvancedSearchManufacturerContainer');
    this.$includeManufacturerCheckbox = this.$form.find('#IncludeManufacturer');
    this.$clearCategoryAutoComplete = this.$form.find('#ClearCategoryAutoComplete');
    this.$arrowsCategoryAutoComplete = this.$form.find('#CategoryAutoCompleteArrows');
    this.$clearManufacturerAutoComplete = this.$form.find('#ClearManufacturerAutoComplete');
    this.$arrowsManufacturerAutoComplete = this.$form.find('#ManufacturerAutoCompleteArrows');
    this.$lastActiveElement = $(document.activeElement);
    this.$chatWithEngineerButton = this.$el.find('.AdvancedSearchContent-engineer--chat-button');
    this.$modalContainer = this.$el.find('.Modal-dialog AdvancedSearch-modal');
    const FOCUSABLE_ELEMENT_SELECTORS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
    const focusableElements = document.getElementById('ParametricSearchModalDialog').querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
    this.$firstElement = $(focusableElements[0]);
    this.initializeControls();
  }

  initializeControls() {
    new AdvancedSearchController({
      $form: this.$form,
      $searchTextBox: this.$searchTextBox,
      $submitButton: this.$submitButton,
      $errorMessage: this.$errorMessage,
      $searchInStockCheckbox: this.$searchInStockCheckbox,
      $searchTopPurchasedCheckbox: this.$searchTopPurchasedCheckbox,
      $searchTopSearchedCheckbox: this.$searchTopSearchedCheckbox,
      $searchNewCheckbox: this.$searchNewCheckbox,
      $closeIcon: this.$closeIcon,
      $categoryList: this.$categoryList,
      $manufacturerList: this.$manufacturerList,
      $parametricList: this.$parametricList,
      $parametricListText: this.$parametricListText,
      $parametricValueList: this.$parametricValueList,
      $parametricValueListText: this.$parametricValueListText,
      $manufacturerLabel: this.$manufacturerLabel,
      $categoryLabel: this.$categoryLabel,
      $manufacturerForCategoryLabel: this.$manufacturerForCategoryLabel,
      $clearManufacturer: this.$clearManufacturer,
      $clearCategory: this.$clearCategory,
      $advMoreParametrics: this.$advMoreParametrics,
      $parametricValues: this.$parametricValues,
      $advancedSearchManufacturerContainer: this.$advancedSearchManufacturerContainer,
      $includeManufacturerCheckbox: this.$includeManufacturerCheckbox,
      $clearCategoryAutoComplete: this.$clearCategoryAutoComplete,
      $arrowsCategoryAutoComplete: this.$arrowsCategoryAutoComplete,
      $clearManufacturerAutoComplete: this.$clearManufacturerAutoComplete,
      $arrowsManufacturerAutoComplete: this.$arrowsManufacturerAutoComplete,
      model: this.model,
      instance: instance,
      $modalContainer: this.$modalContainer
    });
  }

  sendAnalytics(label,
    event = config.analytics.eventTypes.Click,
    category = config.analytics.categoryTypes.AdvancedSearch,
    action = config.analytics.actions.Click) {
    let data = {
      'event': event,
      'category': category,
      'action': action,
      'label': label
    };

    Analytics.pushToEventFramework(data);
  }

  /**
   * Handle the click event to open the Advanced Search modal
   *
   * @param {Event} e
   */
  static handleOpenerClicked(e) {
    e.preventDefault();
    AdvancedSearchModalView.getInstance().open();
  }

  open() {
    this.renderModal();
    super.open();
    this.sendAnalytics(config.analytics.labelTypes.AdvancedSearch);
    if ($('#menuItemBlockLanguage').is(':visible')) {
      $('#menuItemBlockLanguage').hide();
    }
    if ($('#menuItemLanguageClient').is(':visible')) {
      $('#menuItemLanguageClient').hide();
    }
    if ($('#menuItemBlockCurrency').is(':visible')) {
      $('#menuItemBlockCurrency').hide();
    }
  }

  modalClosing() {
    config.analytics.flags.isPopupOn = false;
    super.modalClosing();
    this.$el.removeAttr('aria-modal');
    this.$submitButton.focus();
    var divlist = document.getElementsByClassName('autocomplete-suggestions');
    for (var i = divlist.length - 1; i >= 0; i--) {
      var div = divlist[i];
      div.parentNode.removeChild(div);
    }
  }

  renderModal() {
    let data = {
      liveSupportUrl: config.salesforce.liveAgentSrcUrl,
      analyticsConfig: config.analytics
    };
    // Render main view
    this.$el.html(this.template(data));
  }

  onOpen() {
    config.analytics.flags.isPopupOn = true;
    this.initializeElements();
    this.modifyLiveChatButton();
    this.$el.attr('aria-modal',true);
    document.getElementById('ParametricSearchModalDialog').focus();
    this.$modalContainer.context.firstElementChild.setAttribute('tabindex', 0);
    this.$modalContainer.focus();
    this.$firstElement.on('keydown',(e)=>{
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        if (this.$submitButton.attr('disabled'))
        {
          this.$chatWithEngineerButton.focus();
        } else {
          this.$submitButton.focus();
        }
      }
    });
    this.$chatWithEngineerButton.on('keydown',(e)=>{
      if (e.key === 'Tab' && !e.shiftKey)
      {
        e.preventDefault();
        if (this.$submitButton.attr('disabled'))
        {
          this.$firstElement.focus();
        } else {
          this.$submitButton.focus();
        }
      }
    });
    this.$submitButton.on('keydown',(e)=>{
      if (e.key === 'Tab' && !e.shiftKey)
      {
        e.preventDefault();
        this.$firstElement.focus();
      }
    });
  }

  modifyLiveChatButton() {
    this.$chatButton = this.$el.find('.AdvancedSearchContent-engineer--chat-button');
    const liveSupportUrl = this.$chatButton.attr('href');
    if (!liveSupportUrl) {
      const sparkAssistButton = $('#helpButtonSpan');
      if (sparkAssistButton.length) {
        const closeButton = $('#advSearchCloseBtn');
        this.$chatButton.removeAttr('target');
        this.$chatButton.attr('href', 'javascript:void(0)');
        this.$chatButton.on('click', () => {
          sparkAssistButton.click();
          closeButton.click();
        });
        this.$chatButton.on('keyup', (event) => {
          if (event.keyCode === 13) {
            sparkAssistButton.click();
            closeButton.click();
          }
        });
      }
    }
  }

  /**
   * Get the singleton instance of the AdvancedSearchModal.
   *
   * @returns {AdvancedSearchModalView}
   */
  static getInstance() {
    if (!instance) {
      instance = new AdvancedSearchModalView();
    }

    return instance;
  }

}

export function createAdvancedSearchModalView($parent) {
  let $advancedSearchBtn = $parent.find('.AdvancedSearchBtn');

  if ($advancedSearchBtn.length) {
    $advancedSearchBtn.on('click', AdvancedSearchModalView.handleOpenerClicked);
  }
}



// WEBPACK FOOTER //
// ./assets/components/Header/js/AdvancedSearchModalView.js